var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { width: "100%" } },
      [
        _vm.src.length > 0
          ? _c("pdf", {
              attrs: { src: _vm.source },
              on: {
                progress: function ($event) {
                  _vm.loadedRatio = $event
                },
                error: _vm.error,
                "num-pages": function ($event) {
                  _vm.numPages = $event
                },
                "link-clicked": function ($event) {
                  _vm.page = $event
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }